import { env } from './.env';

export const environment = {
  production: true,
  caching: false,

  basePath: '/assets',
  version: env['npm_package_version'],

  //webstorage: 'https://api.studema.at/api/storage',

  supportedLanguages: ['en-EN', 'de-DE'],

  // WebSocket configuration - point to AI API (always use WSS for external API)
  ws_baseurl: 'wss://ai.olliecourse.com/ws',


  // api key from studema settings
  // every company has its own api key
  //ollieapi_key_studema_settings: 'Mmdoc3dRanJFd0l0ODRxd2F1YkNLb1FudjhYYmR4MUFOVHJJdEVjYnN1Zz0=',
  //api_key_studema_settings: 'd3MyczhGYll0Q3V2RE0waVMzc0pRT1ppU2JHb0V5NW1uU1JmMVc0SWVyVT0=', // knusper

  // tinymce editor
  tinymce_apikey: 'z99ixl4m6oeetlpw3pvfmd8s2suwyuyf2dgzvuyql1kzmfwl',
  // encoding settings
  cloudfrontServerBase: 'https://d2iujko1ysket6.cloudfront.net/',
  jwplayerjs: 'https://cdn.jwplayer.com/libraries/Ls5giHR2.js',
  
  // video player configuration
  useInteractivePlayer: true, // true = Interactive Player, false = JWPlayer
  
  keyServer: 'https://ontarget.management/__kserver/api-kserver.php',
  fallback_wpurl: 'https://kdb.studema.at/',
  //wpurl: 'https://kdb.studema.at/', // + kundenname 
  //wpu: 'nqztybffnel', // rot 13 'admglossary',
  //wpt: 'fpJ&vUmi!^_61K1%', // rot 13 encoded scW&iHzv!^_61X1% -- rot13.com


  // Email debug configuration
  email_debug: {
    enabled: false,
    test_email: '',
    redirect_all_emails: false
  },

  // kdb - wordpress settings

  // api key from studema settings
  // every company has its own api key

  //
  // DEVELOPMENT SETTINGS
  //
  devServerUrl: 'https://ollie.studema.at/',

  //
  // -----------------------------
  //           HIER SIND ES DIE API KEYS VOM DEV SERVER     dev4.studema.at // live system hat andere db
  //            ( es sind NICHT die keys vom live-server !!!)

  // ollie - development :: bei ollie gibt es 2 varianten
  // 1. olliecourse.com - live system
  // 2. olliecourse.com/ollie - development system
  //    die development hat alle features aktiviert > die live nur die funktionierenden features
  ///
  /* 
  client: 'ollie',
  api_key_studema_settings: 'ZjRIalRQaGZzMDlvVlpONFJCMnlBVGxzanRqM1JENVhZTThtL3ZHUE9sTT0=', // ollie

  wpurl: 'https://elementary-marketing-test.com/quotes',
  wpu: 'ryrznqz', // elemadm
  wpt: 'qMAkToRtK4MHfaD%', //'dZNxGbEgX4ZUsnQ%',

  //wpurl: 'https://studio.olliecourse.com/glossary',
  //wpu: 'nqztybffnel', // rot 13 'admglossary',
  //wpt: 'wSXbj9#B8&uzIQALWjXvoe7!', // rot 13 encoded jFKow9#O8&hmVDNYJwKibr7!

  serverUrl: 'https://api.olliecourse.com/api', // server api
  api_baseurl: 'https://api.olliecourse.com/api/v1', // api baseurl -- what is the difference
  ai_api_baseurl_chat: 'https://aichat.olliecourse.com/api', // api for ai-chat system
  ai_api_baseurl: 'https://ai.olliecourse.com', // AI API for subtitles and video processing
  ai_api_client: 'ollie', // the client config for the AI API
  ai_chat_debug: false,
  ai_chat_full_mode: false,
  ai_chat_role: 'executive',
  chat_badge_count: 0,
  stepDataPollingInterval: 5000,
  defaultLanguage: 'en', // language default
  otrainingsystem: 'https://otraining.olliecourse.com/otplus/', // the link to the existing online training backend
  pdfFileServer: 'https://otraining.olliecourse.com', // pdf file server
  pdfCertificateStorage: 'https://otraining.olliecourse.com/otplus/_fileDB/ollie/ollie-the-elephant-11-united-states-48a87f46/', // pdf certificate storage

  classroom_url: 'https://classroom.olliecourse.com', // url to the classroom signal video server

  // Layout features
  feature_header_white_bg: false,
  featuresTopNav: true, // all the features in the topnav
  feature_clearword: true,
  feature_chat_supervisor: true,
  feature_chat_twin: true,
  feature_firststart: true,
  feature_classroom: true,
  feature_progress_rocket: true,
  feature_dashboard_courses: true,
  feature_badges: true,
  feature_ai: true,
  feature_twin: false,

  wording_supervisor: 'Step-Master',
  wording_checksheet: 'Step-Guide',

  top_nav_style: '',
  banner_client_style: '',
  copyright: 'Copyright © {{YEAR}} Clarity International. All Rights Reserved.',
  copyright_link: '',
  copyright_link_title: '',
  link_privacy: '',
  link_terms: '',

  // layout
  branding: 'Ollie the Elephant',
  logo: 'logo-ollie.svg',
  logo_invers: 'logo-ollie.svg',
  bg_login: 'bg-login.jpg',
  bg_header: 'bg-login.jpg',
  // -----------------------------------
  */
  // ollie - live
  /*
  client: 'ollie',
  api_key_studema_settings: 'ZjRIalRQaGZzMDlvVlpONFJCMnlBVGxzanRqM1JENVhZTThtL3ZHUE9sTT0=', // ollie
  wpurl: 'https://olliecourse.com/glossary',
  wpu: 'nqztybffnel', // rot 13 'admglossary',
  wpt: 'fpJ&vUmi!^_61K1%', // rot 13 encoded scW&iHzv!^_61X1%

  serverUrl: 'https://api.olliecourse.com/api', // server api
  api_baseurl: 'https://api.olliecourse.com/api/v1', // api baseurl -- what is the difference
  ai_api_baseurl_chat: 'https://aichat.olliecourse.com/api', // api for ai-chat system
  ai_api_baseurl: 'https://ai.olliecourse.com', // AI API for subtitles and video processing
  ai_api_client: 'ollie', // the client config for the AI API
  ai_chat_debug: true, // Debug mode for AI chat widget (temporarily enabled for debugging)
  ai_chat_full_mode: false, // Full mode for AI chat widget
  ai_chat_role: 'executive', // Default role for AI chat widget ('child' | 'executive')
  chat_badge_count: 0, // Top-nav Chat badge number (0 hides badge; temporary until real chat is implemented)

  // Step data polling interval (in milliseconds)
  stepDataPollingInterval: 5000, // 5 seconds default

  defaultLanguage: 'en', // language default
  otrainingsystem: 'https://otraining.olliecourse.com/otplus/', // the link to the existing online training backend
  pdfFileServer: 'https://otraining.olliecourse.com', // pdf file server
  pdfCertificateStorage: 'https://dev4.studema.at/otplus/_fileDB/ollie-1a6689b4/', // pdf certificate storage

  classroom_url: 'https://classroom.olliecourse.com', // url to the classroom signal video server

  // Layout features
  feature_header_white_bg: false,
  featuresTopNav: true, // all the features in the topnav
  feature_clearword: true,
  feature_chat_supervisor: true,
  feature_chat_twin: false,
  feature_firststart: true,
  feature_classroom: true,
  feature_supervisor: true,
  feature_study_matrix: false,
  feature_student_groups: false,
  feature_reports: false,
  enterprise_edition: false,
  feature_progress_rocket: false,
  feature_dashboard_courses: true,
  feature_badges: false,
  feature_ai: false,
  feature_twin: false,

  wording_supervisor: 'Step-Master',
  wording_checksheet: 'Step-Guide',

  top_nav_style: '',
  banner_client_style: '',
  copyright: 'Copyright © {{YEAR}} Clarity International. All Rights Reserved.',
  copyright_link: '',
  copyright_link_title: '',
  link_privacy: '',
  link_terms: '',

  // layout
  branding: 'Ollie the Elephant',
  logo: 'logo-ollie.svg',
  logo_invers: 'logo-ollie.svg',
  bg_login: 'bg-login.jpg',
  bg_header: 'bg-client.png',
  // -----------------------------------

  */

  // knusperstube
  /* 
  client: 'knusperstube',
  api_key_studema_settings: 'd3MyczhGYll0Q3V2RE0waVMzc0pRT1ppU2JHb0V5NW1uU1JmMVc0SWVyVT0=', // knusper - d3MyczhGYll0Q3V2RE0waVMzc0pRT1ppU2JHb0V5NW1uU1JmMVc0SWVyVT0=
  wpurl: 'https://knusperstube.ontarget.management/glossary',
  wpu: 'nqztybffnel', // rot 13 'admglossary',
  wpt: 'wSXbj9#B8&uzIQALWjXvoe7!', // rot 13 encoded jFKow9#O8&hmVDNYJwKibr7!

  serverUrl: 'https://knusperstube-api.studema.at/api', // server api
  api_baseurl: 'https://knusperstube-api.studema.at/api/v1', // api baseurl -- what is the difference
  ai_api_baseurl_chat: '', // no ai-chat for this client
  ai_api_baseurl: 'https://ai.studema.at', // AI API for subtitles and video processing
  ai_api_client: 'knusperstube', // the client config for the AI API
  ai_chat_debug: false,
  ai_chat_full_mode: false,
  ai_chat_role: 'executive',
  chat_badge_count: 0,
  stepDataPollingInterval: 5000,

  defaultLanguage: 'de-DE', // language default
  otrainingsystem: 'https://knusperstube-otraining.studema.at/otplus/', // the link to the existing online training backend
  pdfFileServer: 'https://knusperstube-otraining.studema.at', // pdf file server
  pdfCertificateStorage: 'https://oh-otraining.studema.at/otplus/_fileDB/knusperstube-3-austria-1a6689b4/', // pdf certificate storage

  classroom_url: 'https://classroom.studema.at', // url to the classroom signal video server

  // Layout features
  feature_header_white_bg: false,
  featuresTopNav: false, // all the features in the topnav
  feature_clearword: true,
  feature_chat_supervisor: true,
  feature_chat_twin: false,
  feature_firststart: true,
  feature_classroom: false,
  feature_supervisor: true,
  feature_study_matrix: false,
  feature_student_groups: false,
  feature_progress_rocket: false,
  feature_dashboard_courses: false,
  feature_badges: true,
  feature_ai: false,
  feature_twin: false,
  feature_reports: false,
  enterprise_edition: false,

  wording_supervisor: 'Kursüberwacher',
  wording_checksheet: 'Checksheet',

  top_nav_style: '',
  banner_client_style: '',
  copyright: 'Alle Rechte vorbehalten | Copyright © {{YEAR}} - ',
  copyright_link: 'https://studema.at',
  copyright_link_title: 'studema.at',
  link_privacy: 'https://studema.at/privacy',
  link_terms: 'https://studema.at/terms',

  // layout
  branding: 'Knusperstube Online Schulungen',
  logo: 'client-logo.png',
  logo_invers: 'client-logo-white.png',
  bg_login: 'bg-login.jpg',
  bg_header: 'bg-login.jpg',
  // -----------------------------------
  */

  // otthaus > gibt es derzeit nur im live system !!!!
  /*
  client: 'otthaus',
  api_key_studema_settings: 'RWVURHRUVklhKzU4WmlYRjUrb01lZk5FOTNmUE5VcFFwQVVLa1RIeUF2UT0=', // otthaus
  wpurl: 'https://oh.ontarget.management/glossary',
  wpu: 'nqztybffnel', // rot 13 'admglossary',
  wpt: 'fpJ&vUmi!^_61K1%', // rot 13 encoded scW&iHzv!^_61X1% -- rot13.com

  classroom_url: 'https://classroom.studema.at', // url to the classroom signal video server

  serverUrl: 'https://oh-api.studema.at/api', // server api
  api_baseurl: 'https://oh-api.studema.at/api/v1', // api baseurl -- what is the difference
  ai_api_baseurl_chat: '', // no ai-chat for this client
  ai_api_baseurl: 'https://ai.studema.at', // AI API for subtitles and video processing
  ai_api_client: 'otthaus', // the client config for the AI API
  ai_chat_debug: false,
  ai_chat_full_mode: false,
  ai_chat_role: 'executive',
  chat_badge_count: 0,
  stepDataPollingInterval: 5000,

  defaultLanguage: 'de-DE', // language default
  otrainingsystem: 'https://oh-otraining.studema.at/otplus/', // the link to the existing online training backend
  pdfFileServer: 'https://oh-otraining.studema.at', // pdf file server
  pdfCertificateStorage: 'https://oh-otraining.studema.at/otplus/_fileDB/ott-haus-12-germany-9979d092/', // pdf certificate storage

  // Layout features
  feature_header_white_bg: false,
  featuresTopNav: false, // all the features in the topnav
  feature_clearword: false,
  feature_chat_supervisor: false,
  feature_chat_twin: false,
  feature_firststart: false,
  feature_classroom: false,
  feature_progress_rocket: false,
  feature_dashboard_courses: false,
  feature_badges: false,
  feature_ai: false,
  feature_twin: false,

  wording_supervisor: 'Supervisor',
  wording_checksheet: 'Checksheet',

  top_nav_style: '',
  banner_client_style: '',
  copyright: 'All Rights Reserved | Copyright © {{YEAR}} - ',
  copyright_link: 'https://studema.at',
  copyright_link_title: 'studema.at',
  link_privacy: 'https://studema.at/privacy',
  link_terms: 'https://studema.at/terms',

  // layout
  branding: 'Ott-Haus Online Schulungen',
  logo: 'ott-haus-logo.webp',
  logo_invers: 'ott-haus-logo-white.png',
  bg_login: 'bg-client.png',
  bg_header: 'bg-header.png',
  // -----------------------------------
*/
  // ontarget
  /*
  client: 'ontarget',
  api_key_studema_settings: 'Mmdoc3dRanJFd0l0ODRxd2F1YkNLb1FudjhYYmR4MUFOVHJJdEVjYnN1Zz0=',
  wpurl: 'https://studio.studema.at/glossary',
  wpu: 'nqztybffnel', // rot 13 'admglossary',
  wpt: 'wSXbj9#B8&uzIQALWjXvoe7!', // rot 13 encoded jFKow9#O8&hmVDNYJwKibr7!

  serverUrl: 'https://api4.studema.at/api', // server api
  api_baseurl: 'https://api4.studema.at/api/v1', // api baseurl -- what is the difference
  ai_api_baseurl_chat: '', // no ai-chat for this client
  ai_api_baseurl: 'https://ai.studema.at', // AI API for subtitles and video processing
  ai_api_client: 'ontarget', // the client config for the AI API
  ai_chat_debug: false,
  ai_chat_full_mode: false,
  ai_chat_role: 'executive',
  chat_badge_count: 0,
  stepDataPollingInterval: 5000,

  defaultLanguage: 'en-EN', // language default
  otrainingsystem: 'https://dev4.studema.at/otplus/', // the link to the existing online training backend
  pdfFileServer: 'https://dev4.studema.at',  // pdf file server

      classroom_url: 'https://classroom.studema.at', // url to the classroom signal video server

      // Layout features
  feature_header_white_bg: false,
  featuresTopNav: false, // all the features in the topnav
  feature_clearword: false,
  feature_chat_supervisor: false,
  feature_chat_twin: false,
  feature_firststart: false,
  feature_classroom: false,
  feature_progress_rocket: false,
  feature_dashboard_courses: false,
  feature_badges: false,
  feature_ai: false,
  feature_twin: false,

  wording_supervisor: 'Supervisor',
  wording_checksheet: 'Checksheet',

  top_nav_style: '',
  banner_client_style: '',
  copyright: 'All Rights Reserved | Copyright © {{YEAR}} - ',
  copyright_link: 'https://studema.at',
  copyright_link_title: 'studema.at',
  link_privacy: 'https://studema.at/privacy',
  link_terms: 'https://studema.at/terms',

  // layout
  branding: 'ontarget Online Schulungen',
  logo: 'ontarget-logo.png',
  logo_invers: 'ontarget-logo-white.png',
  bg_login: 'bg-login.jpg',
  bg_header: 'bg-login.jpg',
  // -----------------------------------
  */

  // performmia
  /*
  client: 'performia',
  api_key_studema_settings: 'xyzMmdoc3dRanJFd0l0ODRxd2F1YkNLb1FudjhYYmR4MUFOVHJJdEVjYnN1Zz0=', // performia site key
  //api_key_studema_settings: 'MIICXQIBAAKBgQCkFpnNU/ld8nUAN2YCd9j1Yj6AxNwW0Vrb/4kq4NRH8vA3xuVS', // otthaus
  wpurl: 'https://ot.performiatraining.com/kdb',
  wpu: 'nqztybffnel', // rot 13 'admglossary',
  wpt: 'fpJ&vUmi!^_61K1%', // rot 13 encoded scW&iHzv!^_61X1% -- rot13.com

  classroom_url: 'https://classroom.studema.at', // url to the classroom signal video server

  serverUrl: 'https://api.performiatraining.com/api', // server api
  api_baseurl: 'https://api.performiatraining.com/api/v1', // api baseurl -- what is the difference
  ai_api_baseurl_chat: '', // no ai-chat for this client
  ai_api_baseurl: 'https://whisper.kopilot.at', // AI API for subtitles and video processing
  ai_api_client: 'performia', // the client config for the AI API
  ai_chat_debug: false,
  ai_chat_full_mode: false,
  ai_chat_role: 'executive',
  chat_badge_count: 0,
  stepDataPollingInterval: 5000,

  defaultLanguage: 'en', // language default
  otrainingsystem: 'https://ot.performiatraining.com/otplus/', // the link to the existing online training backend
  pdfFileServer: 'https://ot.performiatraining.com', // pdf file server
  pdfCertificateStorage: 'https://ot.performiatraining.com/otplus/_fileDB/performia/', // pdf certificate storage

  featuresTopNav: true, // all the features in the topnav
  feature_clearword: true,
  feature_chat_supervisor: true,
  feature_chat_twin: false,
  // Layout features
  feature_header_white_bg: true,
  feature_firststart: false,
  feature_classroom: false,
  feature_progress_rocket: false,
  feature_dashboard_courses: false,
  feature_badges: false,
  feature_ai: false,
  feature_twin: false,

  wording_supervisor: 'Supervisor',
  wording_checksheet: 'Checksheet',

  top_nav_style: '',
  banner_client_style: '',
  copyright: 'All Rights Reserved | Copyright © {{YEAR}} - ',
  copyright_link: 'https://studema.at',
  copyright_link_title: 'studema.at',
  link_privacy: 'https://studema.at/privacy',
  link_terms: 'https://studema.at/terms',

  // layout
  branding: 'Performia Online Training',
  logo: 'performia.png',
  logo_invers: 'performia-white.png',
  bg_login: 'bg-client.png',
  bg_header: 'bg-header.png',
  // -----------------------------------
  */
  
  // STUDEMA 
  //      next.studema.at platform with 
  //      studio.studema.at frontend
  //      studeio.studema.at/api for the api
  /* */
  client: 'studema',
  api_key_studema_settings: 'xyzMmdoc3dRanJFd0l0ODRxd2F1YkNLb1FudjhYYmR4MUFOVHJJdEVjYnN1Zz0=', // studema site key
  //api_key_studema_settings: 'MIICXQIBAAKBgQCkFpnNU/ld8nUAN2YCd9j1Yj6AxNwW0Vrb/4kq4NRH8vA3xuVS', // otthaus

  wpurl: 'https://kdb.studema.at/',
  wpu: 'nqztybffnel', // rot 13 'admglossary',
  wpt: 'wSXbj9#B8&uzIQALWjXvoe7!', // rot 13 encoded jFKow9#O8&hmVDNYJwKibr7!

  classroom_url: 'https://classroom.studema.at', // url to the classroom signal video server

  serverUrl: 'https://studio.studema.at/api', // server api
  api_baseurl: 'https://studio.studema.at/api/v1', // api baseurl -- what is the difference
  ai_api_baseurl_chat: '', // no ai-chat for this client yet
  ai_api_baseurl: 'https://ai.studema.at', // AI API for subtitles and video processing // auf oh server !!
  ai_api_client: 'studema', // the client config for the AI API
  ai_chat_debug: false,
  ai_chat_full_mode: false,
  ai_chat_role: 'executive',
  chat_badge_count: 0,
  stepDataPollingInterval: 5000,

  defaultLanguage: 'en', // language default
  otrainingsystem: 'https://next.studema.at/otplus/', // the link to the existing online training backend
  pdfFileServer: 'https://next.studema.at', // pdf file server
  pdfCertificateStorage: 'https://next.studema.at/otplus/_fileDB/studema/', // pdf certificate storage

  featuresTopNav: true, // all the features in the topnav
  feature_clearword: true,
  feature_chat_supervisor: true,
  feature_chat_twin: false,
  // Layout features
  feature_header_white_bg: true,
  feature_firststart: true,
  feature_classroom: true,
  feature_supervisor: true,
  feature_study_matrix: false,
  feature_student_groups: false,
  feature_progress_rocket: false,
  feature_dashboard_courses: true,
  feature_badges: false,
  feature_ai: false,
  feature_twin: false,
  feature_reports: false,
  enterprise_edition: false,

  wording_supervisor: 'Supervisor',
  wording_checksheet: 'Checksheet',

  top_nav_style: '',
  banner_client_style: '',
  copyright: 'All Rights Reserved | Copyright © {{YEAR}} - ',
  copyright_link: 'https://studema.at',
  copyright_link_title: 'studema.at',
  link_privacy: 'https://studema.at/privacy',
  link_terms: 'https://studema.at/terms',

  // layout
  branding: 'Studema Online Training',
  logo: 'studema-logo.png',
  logo_invers: 'studema-logo-white.png',
  bg_login: 'bg-client.jpg',
  bg_header: 'bg-header.jpg',
  // -----------------------------------
  

  // dev 4 - studema
  /*
  client: 'dev4',
  api_key_studema_settings: 'd3MyczhGYll0Q3V2RE0waVMzc0pRT1ppU2JHb0V5NW1uU1JmMVc0SWVyVT0=', // knusper
  wpurl: 'https://knusperstube.ontarget.management/glossary',
  wpu: 'nqztybffnel', // rot 13 'admglossary',
  wpt: 'wSXbj9#B8&uzIQALWjXvoe7!', // rot 13 encoded jFKow9#O8&hmVDNYJwKibr7!

  ai_api_baseurl_chat: '', // no ai-chat for this client
  ai_chat_debug: false,
  ai_chat_full_mode: false,
  ai_chat_role: 'executive',
  chat_badge_count: 0,
  stepDataPollingInterval: 5000,
  feature_twin: false,

  branding: 'Studema Online Training',
  logo: 'client-logo.png',
  logo_invers: 'studema-logo-white.png',
  bg_login: 'bg-login.jpg',
  bg_header: 'bg-login.jpg',
  */
};
